import { useEffect, useState } from 'react'
import { cx } from './cx.ts'

/** A spinner that only appears after `delay` ms (200 by default), so fast work never flickers. */
export function Spinner({ delay = 200, className, label = 'Loading' }: { delay?: number; className?: string; label?: string }) {
  const [shown, setShown] = useState(delay <= 0)
  useEffect(() => {
    if (delay <= 0) return
    const t = window.setTimeout(() => setShown(true), delay)
    return () => window.clearTimeout(t)
  }, [delay])
  if (!shown) return null
  return <span className={cx('rt-spinner', className)} role="status" aria-label={label} />
}
